import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  private subject = new Subject<any>();

  sendAlert(message: string, silent: boolean = false) {
    this.subject.next({ alert: message, silent });
  }

onAlert(): Observable<any> {
  return this.subject.asObservable();
}

  constructor() { }
}
